<template>
  <v-layout column align-center class="app-selector">
    <v-btn 
      color="grey lighten-2"
      icon 
      class="nav-up-button"
      light
      fab      
      @click="scrollToIntro()"
      >      
      <v-icon>expand_less</v-icon>
    </v-btn>

    <v-toolbar
      :clipped-left="clipped"
    >
      <div class="logo">
        <img width="60%" src="@/assets/jll-logo.png">
      </div>

      <!-- <v-layout column align-center>        
        <div id="nav" :height="44">

          <v-btn-toggle
            v-model="subApp"
            light
          >
            <v-btn 
              value="analyzer"
              to="/"
            >
              <v-icon>bar_chart</v-icon>
              <span class="hidden-xs-only">Network Builder</span>
            </v-btn>

            <v-btn 
              value="calculator"
              to="/calculator"
            >
              <v-icon>apps</v-icon>
              <span class="hidden-xs-only">Site Selector</span>
            </v-btn>
          </v-btn-toggle>
        </div>
      </v-layout> -->

      <div class="busy-indicator">
        <v-progress-circular 
          v-if="requestInProcess"
          indeterminate
          color="blue darken-3"
        >
        </v-progress-circular>
      </div>
    </v-toolbar>

    <router-view></router-view>
  </v-layout>
</template>


<script>
export default {
  data () {
    return {
      name: "app-selector",
      clipped: false,
      subApp: "analyzer"
    }
  },

  props: [ 
    "fullpageController" 
  ],

  methods: {
    scrollToIntro: function() { 
      this.$parent.$parent.$data.pagingEnabled = true
      this.fullpageController().movePrev()
    }
  },

  computed: {
    requestInProcess() {
      return this.$store.getters.serverRequestInProcess
    }

  }
}

</script>


<style scoped>
.nav-up-button {
  position: absolute;
  top: 7px;
  left: 13px;
  width: 34px;
  height: 34px;
  z-index: 10;  
}
.busy-indicator {
  position: absolute;
  width: 40px;
  height: 40px;
  right: 25px;
  
}
.app-selector {
  height: 100%;
  width: 100%;
}
.logo {
  position: absolute;
  right: 0px;
}
a:hover {
  font-weight: bold;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
</style>
